// Türkçe metin ve telefon yardımcıları (arama, müşteri eşleştirme) — saf fonksiyonlar.
//
// toLowerCase() Türkçe bilmez: 'İbrahim'.toLowerCase() = 'i̇brahim' (i + birleşik nokta) → 'ibrahim' aramasıyla eşleşmez.
// foldTr hem büyük/küçük harfi hem Türkçe karakterleri katlar: "IŞIK", "ışık", "isik" aynı anahtara iner.

export const foldTr = (value) => String(value ?? '')
  .toLocaleLowerCase('tr')
  .replace(/ı/g, 'i')
  .replace(/ş/g, 's')
  .replace(/ç/g, 'c')
  .replace(/ğ/g, 'g')
  .replace(/ö/g, 'o')
  .replace(/ü/g, 'u')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '') // â, î, û ve birleşik noktalar
  .replace(/\s+/g, ' ')
  .trim();

export const digitsOnly = (value) => String(value ?? '').replace(/\D/g, '');

// Telefon anahtarı: son 10 hane → "0532 123 45 67", "+90 532 123 4567", "905321234567" aynı numara.
// 7 haneden kısa (eksik/hatalı) numara eşleştirmede kullanılmaz → ''.
export const phoneKey = (value) => {
  const d = digitsOnly(value);
  return d.length >= 7 ? d.slice(-10) : '';
};

// E-posta anahtarı (boşluksuz, küçük harf)
export const emailKey = (value) => String(value ?? '').trim().toLocaleLowerCase('en');

// Instagram anahtarı (@ ve boşluk atılır)
export const instagramKey = (value) => String(value ?? '').trim().replace(/^@+/, '').toLocaleLowerCase('en');

// Sorgu yalnızca telefon karakterlerinden mi oluşuyor? ("0532 123", "+90 (532) 123-45")
const looksLikePhone = (query) => /^[\d\s()+\-.]+$/.test(String(query ?? '').trim()) && digitsOnly(query).length >= 3;

// Telefon rakamlarını ülke kodu / baştaki 0 olmadan yazar: "+90 532…", "0090 532…", "0532…" → "532…".
// Alan birden çok numara içerebilir ("0532 … - 0533 …"): her numara ayrı normalleştirilir.
const phoneCores = (value) => String(value ?? '')
  .split(/[,;/|]| - /)
  .map((part) => digitsOnly(part).replace(/^00/, '').replace(/^90(?=5\d{2})/, '').replace(/^0+/, ''))
  .filter(Boolean);

// Arama: metin sorgusunda HER kelime alanlardan birinde geçmeli (Türkçe katlamalı; baştaki @ yok sayılır).
// Telefon sorgusunda (en az 3 rakam) normalleştirilmiş rakamlar aranır; baştaki 0 / 90 / +90 farkı önemsizdir.
export const matchesSearch = (fields, query) => {
  const q = foldTr(query);
  if (!q) return true;
  const list = (fields || []).filter((f) => f !== null && f !== undefined && f !== '');
  if (looksLikePhone(query)) {
    const [core] = phoneCores(query);
    if (!core) return false;
    return list.some((f) => phoneCores(f).some((c) => c.includes(core)) || digitsOnly(f).includes(core));
  }
  const hay = list.map(foldTr).join(' | ');
  return q.split(' ').map((w) => w.replace(/^@+/, '')).filter(Boolean).every((word) => hay.includes(word));
};
